import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

type ButtonStyle = 'secondary' | true

interface Props {
  /** To render link as primary or secondary button */
  button?: ButtonStyle | null
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BaseLink'
},
  __name: 'BaseLink',
  props: {
    button: { type: [String, Boolean, null], default: null }
  },
  setup(__props: any) {





const classes = computed(() => {
  if (__props.button) {
    let buttonClasses =
      'h-10 inline-flex items-center px-4 text-sm font-medium hover:shadow-sm'

    if (__props.button === 'secondary') {
      buttonClasses += ' border border-primary text-primary'
    } else {
      buttonClasses += ' bg-primary text-white'
    }

    return buttonClasses
  }

  return 'text-primary underline inline-block'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(classes.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})